import React from 'react';
import classnames from 'classnames';
import { compose, withPropsOnChange } from 'recompose';
import styles from '../../styles/components/property-card.module.scss';
import { renderAsCard } from '../card';
import { AffiliateIcon } from '../icons/affiliate-icon';

const Content = React.memo(({ action, icon = 'card-action', children }) => {
  return (
    <>
      {children}
      {(action || icon) && (
        <Section renderAs='footer' className={styles.footer}>
          {action && <p className={styles.action}>{action}</p>}
          {icon && <AffiliateIcon name={icon} className={styles.icon} />}
        </Section>
      )}
    </>
  );
});

export const Section = ({ renderAs: Component = 'section', children, keyline, grow, className, onClick, ...props }) => (
  <Component
    className={classnames(styles.section, { [styles.keyline]: keyline, [styles.grow]: grow }, className)}
    onClick={onClick}
    {...props}
  >
    {children}
  </Component>
);

export const InfoButton = ({ onClick }) => {
  return (
    <div className={styles.info} onClick={onClick}>
      <AffiliateIcon className={styles['info-icon']} name='info' />
    </div>
  );
};

export const PropertyCard = compose(
  withPropsOnChange(['className'], ({ className }) => ({
    className: classnames(styles.container, className)
  })),
  renderAsCard
)(Content);
